// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-header {
  position: fixed;
  top: 0;
  height: 4%;
  width: 100%;
  z-index: 1000;
  background-color: #e4eee7fd;
  color: white;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  pointer-events: auto;
}

/* .profile-buttons{
  z-index:1000;
  position: sticky;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-right: 40px;
} */

.map-footer {
  position: fixed;
  bottom: 0;
  height: 4%;
  width: 100%;
  z-index: 1000;
  background-color: #e4eee7fd;
  color: white;
  padding: 10px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  pointer-events: auto;
}

.event-buttons {
  display: flex;
  gap: 10px;
}

.plus-icon-container{
  height:38px;
  width:38px;
  border-radius:50%;
  background-color: white;
}

#map-header{
  height:70px;
  padding:0px;
}

#map-footer{
  height:50px;
  padding:0px;
}

/* #header-name{
  z-index: 10000;
  color:white;
  padding-left: 20px;
  padding-right:20px;
  background-color: #007bff;;
}

#header-name-2{
  z-index: 10000;
  color:white;
  padding-left: 20px;
  padding-right:20px;
  background-color: #007bff;;
} */

@media (max-width: 767px) {
  .map-header{
    margin-top:5px;
    margin-left:0px;
    margin-right:0px;
  }
}

/*subset of event buttons, includes show nearest events and view locations */
.constant-buttons{
  z-index: 1000;
  position: sticky;
  display: flex;
}

/*subset of event buttons, includes add event, add location, check in */
.signed-in-buttons{
  z-index:1000;
  position:relative;
  margin-top:10px;
  display: flex;
}

@media (max-width: 650px) {
  .signed-in-buttons{
    z-index:1000;
    margin-top:0px;
    
  }
}


/* centre map on user and back to all events view */
.location-load-buttons{
  z-index:1000;
  position: sticky;
  display: flex;
  margin-bottom:10px;
}
`, "",{"version":3,"sources":["webpack://./src/css/mapPage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,UAAU;EACV,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;;;;;GAOG;;AAEH;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;;;;;;;;;;;;;;GAcG;;AAEH;EACE;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA,uEAAuE;AACvE;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;;AAEA;EACE;IACE,YAAY;IACZ,cAAc;;EAEhB;AACF;;;AAGA,mDAAmD;AACnD;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB","sourcesContent":[".map-header {\n  position: fixed;\n  top: 0;\n  height: 4%;\n  width: 100%;\n  z-index: 1000;\n  background-color: #e4eee7fd;\n  color: white;\n  padding: 10px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  pointer-events: auto;\n}\n\n/* .profile-buttons{\n  z-index:1000;\n  position: sticky;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-right: 40px;\n} */\n\n.map-footer {\n  position: fixed;\n  bottom: 0;\n  height: 4%;\n  width: 100%;\n  z-index: 1000;\n  background-color: #e4eee7fd;\n  color: white;\n  padding: 10px;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  pointer-events: auto;\n}\n\n.event-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.plus-icon-container{\n  height:38px;\n  width:38px;\n  border-radius:50%;\n  background-color: white;\n}\n\n#map-header{\n  height:70px;\n  padding:0px;\n}\n\n#map-footer{\n  height:50px;\n  padding:0px;\n}\n\n/* #header-name{\n  z-index: 10000;\n  color:white;\n  padding-left: 20px;\n  padding-right:20px;\n  background-color: #007bff;;\n}\n\n#header-name-2{\n  z-index: 10000;\n  color:white;\n  padding-left: 20px;\n  padding-right:20px;\n  background-color: #007bff;;\n} */\n\n@media (max-width: 767px) {\n  .map-header{\n    margin-top:5px;\n    margin-left:0px;\n    margin-right:0px;\n  }\n}\n\n/*subset of event buttons, includes show nearest events and view locations */\n.constant-buttons{\n  z-index: 1000;\n  position: sticky;\n  display: flex;\n}\n\n/*subset of event buttons, includes add event, add location, check in */\n.signed-in-buttons{\n  z-index:1000;\n  position:relative;\n  margin-top:10px;\n  display: flex;\n}\n\n@media (max-width: 650px) {\n  .signed-in-buttons{\n    z-index:1000;\n    margin-top:0px;\n    \n  }\n}\n\n\n/* centre map on user and back to all events view */\n.location-load-buttons{\n  z-index:1000;\n  position: sticky;\n  display: flex;\n  margin-bottom:10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
